import { Instance, SnapshotIn, types } from 'mobx-state-tree';
import { ReportStatus, ReportStatuses } from 'globals/types';

export interface SingleReportProps {
  id: number;
  name: string;
  email: string;
  code: string;
  statusType: ReportStatus;
  date: number;
}

export const SingleReport = types.model({
  id: types.number,
  name: types.string,
  email: types.string,
  code: types.string,
  statusType: types.optional(
    types.enumeration(ReportStatuses),
    ReportStatus.IN_PROGRESS
  ),
  date: types.number,
});

export type SingleReportSnapshot = SnapshotIn<typeof SingleReport>;
export type SingleReportInstance = Instance<typeof SingleReport>;
